export default __webpack_public_path__ + "static/media/head-logo.fa08ee40.svg";